module.exports = __webpack_public_path__ + "static/media/SPADE-13-KING.2e5cc86a.svg";